<template>
<!-- eslint-disable max-len -->
<list-page
  name="Registration Link"
  use="_id"
  :display="display"
  page-prefix="/blade/registration-links"
  :fetch="getRegistrationLinks"
  :remove="deleteRegistrationLink"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getRegistrationLinks',
      'deleteRegistrationLink',
    ]),
    display({ name: environmentName, active, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${environmentName}${active ? ' (ACTIVE)' : ''} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/RegistrationLinkList.vue